import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

const TINT = {
  teal: "rec-tint-teal",
  amber: "rec-tint-amber",
  green: "rec-tint-green",
  info: "rec-tint-info",
};

/* Compact KPI strip used at the top of list pages (port of the design
   prototype's KpiStrip). items: [{icon, value, unit, label, tint}] */
export default function KpiStrip({ items, cols, className }) {
  return (
    <div
      className={`rec-kpi-strip grid gap-rec${className ? ` ${className}` : ""}`}
      style={{ "--kpi-cols": cols || items.length }}
    >
      {items.map((it) => (
        <div key={it.label} className="rec-card rec-card-pad flex items-center gap-[14px]">
          <div className={`rec-kpi-ic ${TINT[it.tint] || TINT.teal}`}>
            <Icon name={it.icon} fill />
          </div>
          <div className="min-w-0">
            <div className="rec-kpi-value" style={{ fontSize: 23 }}>
              {it.value}
              {it.unit && <small>{it.unit}</small>}
              {it.sub && <small className="opacity-70 font-medium">{it.sub}</small>}
            </div>
            <div className="rec-kpi-label whitespace-nowrap overflow-hidden text-ellipsis">
              {it.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

KpiStrip.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired,
      unit: PropTypes.node,
      sub: PropTypes.node,
      label: PropTypes.node.isRequired,
      tint: PropTypes.oneOf(["teal", "amber", "green", "info"]),
    })
  ).isRequired,
  cols: PropTypes.number,
  className: PropTypes.string,
};

KpiStrip.defaultProps = {
  cols: undefined,
  className: "",
};
